import { render, staticRenderFns } from "./MedicalInsuranceRequest.vue?vue&type=template&id=9a6be6a2"
import script from "./MedicalInsuranceRequest.vue?vue&type=script&lang=js"
export * from "./MedicalInsuranceRequest.vue?vue&type=script&lang=js"
import style0 from "./MedicalInsuranceRequest.vue?vue&type=style&index=0&id=9a6be6a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports